import algoliasearch from 'algoliasearch/lite';
import { createNullCache } from '@algolia/cache-common'

export const Client = algoliasearch(
    process.env.VUE_APP_ALGOLIA_APP_ID,
    process.env.VUE_APP_ALGOLIA_SEARCH_ONLY_KEY
);

export const UserIndex = Client.initIndex(process.env.VUE_APP_ALGOLIA_INDEX_USER);
export const ExerciseIndex = Client.initIndex(process.env.VUE_APP_ALGOLIA_INDEX_EXERCISE);
export const RoutineIndex = Client.initIndex(process.env.VUE_APP_ALGOLIA_INDEX_ROUTINE);
export const ProgramIndex = Client.initIndex(process.env.VUE_APP_ALGOLIA_INDEX_PROGRAM);
export const BlockIndex = Client.initIndex(process.env.VUE_APP_ALGOLIA_INDEX_BLOCK);
export const PrescriptionIndex = Client.initIndex(process.env.VUE_APP_ALGOLIA_INDEX_PRESCRIPTION);
